import React, { useState, useEffect, useRef } from "react";
import { IoIosArrowBack } from "react-icons/io";
import "./tokensale.css";
import { ethers } from "ethers";
import axios from "axios";
import CryptoJS from "crypto-js";
import logo from "../../assets/images/LOI 32x32 Logo.png";
import { useAccount } from "wagmi";
import MudrexURL from "../MudrexURL/MudrexURL"; // Make sure to provide the correct path to your MudrexURL component
import { AiOutlineClose } from "react-icons/ai";
let paymentUrl;

function TokenSale({ account, contract }) {
  const [popup, setPopup] = useState(false);
  const [popup2, setPopup2] = useState(false);
  const [sliderCount, setSliderCount] = useState(0);
  const [sliderCountPercent, setSliderCountPercent] = useState(0);
  const [maticPrice, setMaticPrice] = useState(null);
  const [LOIinMatic, setLOIinMatic] = useState(null);
  const [MaxMin, setMaxMin] = useState("Max");
  const matic = useRef("");
  const [credentials, setCredentials] = useState(null);
  const [openMudrex, setOpenMudrex] = useState(false);
  const [slicedAccount, setSlicedAccount] = useState("");
  // const [userId, setUserId] = useState("");
  const [paymentPopup, setPaymentPopUp] = useState(false);
  let userId;

  const [MaxMinValueSet, setMaxMinValue] = useState(null);
  const address = "0xE2c1efc7322bc478285E39820AEC9b79275e521c";
  const maticValueRef = useRef("");

  const getSoldTokens = async () => {
    // console.log("hii");
    if (contract) {
      await contract;
      let value = await contract.getSoldTokens();
      value = value - (value % 1e18);
      value = value / 1e18 + 590239990;
      // console.log(value);
      setSliderCount(value);
      const inPercent = ((value / 1e18 + 590239990) * 100) / 12000000000;
      setSliderCountPercent(inPercent.toFixed(5));
      // console.log("hello", sliderCount, inPercent);
    }
  };

  const [email, setEmail] = useState("");
  const [metaWalletAddress, setMetaWalletAddress] = useState(
    account ? account : ""
  );

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleWalletAddressChange = (event) => {
    setMetaWalletAddress(event.target.value);
  };

  const HandelPayment = async () => {
    // console.log("starting...");

    console.log(
      "entered and searching for ",
      `https://loop-of-infinity.onrender.com/metapayment?metaWalletAddress=${metaWalletAddress}`
    );
    try {
      const response = await axios.get(
        `https://loop-of-infinity.onrender.com/metapayment?metaWalletAddress=${metaWalletAddress}`
      );
      const returnedResponse = response.data;
      setCredentials(returnedResponse);
      let credentialss = response.data;
      console.log(credentials, credentialss);
      if (credentials || credentialss) {
        if (credentialss._paymentUrl) {
          paymentUrl = credentialss._paymentUrl;
          setPaymentPopUp(true);
        }
        console.log(paymentUrl);
        // setUserId(credentialss.userId);
        userId = credentialss.userId;
        console.log(userId);

        const formData = {
          userId,
          metaWalletAddress,
          email,
        };
        console.log(credentialss.isPresent);

        if (credentialss.isPresent === false) {
          console.log("Sending data to backend for storage...");
          await axios
            .post(
              `https://loop-of-infinity.onrender.com/api/metapayment`,
              formData,
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              console.log("Response data:", formData, response.data);
            })
            .catch((error) => {
              console.error("Error:", error);
            });
          console.log("Data sent to backend for storage.");
        }
      }
      console.log("function ended");
      setOpenMudrex(true);
    } catch (error) {
      console.log(error);
    }
  };

  async function addTokenToWallet() {
    try {
      const wasAdded = await window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: "0xE2c1eFc7322bc478285E39820AEC9b79275E521c",
            symbol: "LOI",
            decimals: "18",
            image: { logo },
          },
        },
      });

      if (wasAdded) {
        // console.log("Great!");
      } else {
        // console.log("Fine!");
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    const fetchMaticPrice = async () => {
      try {
        const response = await fetch(
          "https://api.coingecko.com/api/v3/simple/price?ids=matic-network&vs_currencies=usd"
        );
        const data = await response.json();
        const price = data["matic-network"].usd;
        setMaticPrice(price);
        // console.log(price);
      } catch (error) {
        console.error("Error fetching MATIC price:", error);
      }
    };
    function truncateEthereumAddress(account) {
      const prefix = account.substring(0, 6);
      const suffix = account.substring(account.length - 4);
      setSlicedAccount(`${prefix}...${suffix}`);
      return `${prefix}...${suffix}`;
    }

    if (account) {
      truncateEthereumAddress(account);
    }
    getSoldTokens();

    fetchMaticPrice();
  });
  const handleMaticChange = (event) => {
    const value = event.target.value;
    matic.current = value;
    const x = (value * maticPrice) / 0.008;
    setLOIinMatic(x);
  };

  const purchaseTokens = async () => {
    const value = maticValueRef.current.value;
    const amount = ethers.utils.parseUnits(value, 18);
    const gasLimit = 3000000; // Set an appropriate gas limit value
    await contract.purchaseTokens({ value: amount, gasLimit });
  };

  const max_min = () => {
    if (MaxMin === "Max") {
      setMaxMin("Min");
      const x = 10000 / maticPrice;
      setMaxMinValue(x);
    }
    if (MaxMin === "Min") {
      setMaxMin("Max");
      const x = 10 / maticPrice;
      setMaxMinValue(x);
    }
  };

  return (
    <div className="token-sale">
      {/* <MudrexURL paymentUrl={paymentUrl} /> */}

      <div className={` ${popup ? "popup-container" : "hide"} `}>
        <div
          className={`${
            popup2 ? "blur floating-container" : "floating-container"
          }`}
        >
          <div className="top-float">
            <IoIosArrowBack
              size={24}
              onClick={() => {
                setPopup(false);
              }}
              className="Back-btn"
            />
            <h3>Exchange</h3>
            <div></div>
          </div>
          <div className="exchange">
            <div className="top-float">
              <div className="select">
                <p>From</p>
                <p>MATIC</p>
              </div>
              <div className="input">
                <div className="value">
                  <input
                    type="text"
                    placeholder="0"
                    value={MaxMinValueSet ? MaxMinValueSet : matic.current}
                    ref={maticValueRef}
                    onClick={() => {
                      setMaxMinValue(null);
                    }}
                    onChange={handleMaticChange}
                  />
                  <p
                    className="max-min"
                    onClick={() => {
                      max_min();
                    }}
                  >
                    {MaxMin}
                  </p>
                </div>
              </div>
            </div>
            <div className="price-matic">Price 1 Matic - ${maticPrice}</div>

            <div className="bottom-float">
              <div className="select">
                <p>To</p>
                {/* <select name="" id=""></select> */}
                <p>LOI</p>
              </div>
              <div className="input">
                <div className="value">
                  <p>
                    {MaxMinValueSet ? (
                      <>
                        <p>{MaxMin === "Min" ? "1250000" : ""}</p>
                        <p>{MaxMin === "Max" ? "1250" : ""}</p>
                      </>
                    ) : (
                      LOIinMatic
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="price-loi">Price 1 INFINITY - $0.0080</div>

          <button
            onClick={() => {
              if (account) {
                purchaseTokens();
              } else {
                alert("Please connect your Wallet !");
              }
            }}
          >
            Buy Now
          </button>
          <button
            onClick={() => {
              alert(
                "After successfull UPI Payment it will take 24hrs to get your INFINITY Tokens!"
              );
              setPopup2(true);
            }}
            // disabled
            // style={{ opacity: 0.2 }}
          >
            Payment via UPI
          </button>
        </div>
      </div>
      <div className={`${popup2 ? "popup2-container" : "hide"}`}>
        {paymentPopup ? (
          <div
            style={{
              position: "fixed",
              zIndex: 25,
              height: "70vh",
              borderRadius: "10px",
            }}
          >
            <AiOutlineClose
              size={24}
              onClick={() => setPaymentPopUp(false)}
              style={{ cursor: "pointer" }}
            />
            <MudrexURL paymentUrl={paymentUrl} />
          </div>
        ) : (
          <>{console.log("afa")}</>
        )}
        <form
          method="post"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <IoIosArrowBack
            size={24}
            onClick={() => {
              setPopup2(false);
            }}
            className="Back-btn"
          />
          <input
            type="email"
            placeholder="Email Address"
            onChange={handleEmailChange}
            required
          />
          {account ? (
            <input type="text" value={account} required />
          ) : (
            <input
              type="text"
              required
              onChange={handleWalletAddressChange}
              placeholder="Wallet Address"
            />
          )}
          <button
            type="submit"
            onClick={() => {
              HandelPayment();
            }}
          >
            Proceed to Pay
          </button>
        </form>
      </div>
      <div className={`${popup || popup2 ? "blur container1" : "container1"}`}>
        <h1 className=" days-one">INFINITY Token Sale</h1>
        <div className="bottom">
          <div className="left">
            <div className="heading days-one">About Token</div>
            <div className="token-info">
              <div className="main-info">
                <p>INFINITY Token Official Contract Address</p>
                <a
                  className="address-link"
                  href={`https://polygonscan.com/address/${address}`}
                >
                  {window.innerWidth > 1000 ? address : "0xE2c1...521c"}
                </a>
              </div>
              <hr />
              <div className="each-info">
                <p>Blockchain</p>
                <p>Polygon Mainnet</p>
              </div>
              <hr />
              <div className="each-info">
                <p>Token Name</p>
                <p>LOI</p>
                <button
                  onClick={() => {
                    addTokenToWallet();
                  }}
                >
                  Add token
                </button>
              </div>
              <hr />
              <div className="each-info">
                <p>Pre-Sell Supply</p>
                <p>17.25% (11.99B - 150B)</p>
              </div>
              <hr />
              <div className="each-info">
                <p>Your Wallet Address</p>
                <p>{account ? slicedAccount : "Not Connected"}</p>
              </div>
              <hr />
            </div>
            <div className="info">
              <b>Bonus Tier</b>
              <p>
                We're excited to introduce our Bonus Tiers, designed to provide
                even more rewards and incentives to our valued investors. At
                Loop Of Infinity, we believe in creating a robust ecosystem that
                benefits all participants. By participating in our token sale,
                you're not just investing; you're becoming part of a thriving
                community.
              </p>
              <ul>
                <li>
                  <b>Tier 1: $10 to $999 - Enjoy a 42% Bonus</b>
                  <p>
                    Invest within this range, and you'll receive a substantial
                    42% bonus on your tokens. We appreciate every contribution,
                    and this bonus is our way of showing our gratitude for your
                    support.
                  </p>
                </li>
                <li>
                  <b>Tier 2: $1000 to $4999 - Unlock a 62% Bonus</b>
                  <p>
                    For those looking to make a more significant investment, our
                    Tier 2 bonus offers an impressive 62% additional tokens.
                    This tier is perfect for investors who recognize the
                    potential of Loop Of Infinity and want to maximize their
                    participation.
                  </p>
                </li>
                <li>
                  <b>Tier 3: $5000 and Above - Experience an 82% Bonus</b>
                  <p>
                    At the highest tier, you'll be rewarded with an 82% bonus on
                    your tokens. This tier is tailor-made for serious investors
                    who believe in our project's vision and want to be part of
                    its substantial growth.
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="right">
            <div className="heading  days-one">Buy Tokens</div>
            <div className="slider-div">
              <div className="slider-bg">
                <div
                  className="slider"
                  style={{ width: `${sliderCountPercent}%` }}
                ></div>
              </div>
              <div className="slider-count">
                <div className="sold"> INFINITY Tokens Sold</div>
                <div className="total"> {sliderCountPercent}% Sold</div>
              </div>
              <div className="slider-count">
                <div className="sold">{sliderCount}</div>
                <div className="total">11.99 Billion</div>
              </div>
            </div>

            <div className="some-info">
              <div className="each-info">
                <p>Current INFINITY Price</p>
                <p>$0.008</p>
              </div>
              <div className="each-info">
                <p>Minimum purchase</p>
                <p>$10</p>
              </div>
              <div className="each-info">
                <p>Purchace Limit per wallet</p>
                <p>$10000</p>
              </div>
            </div>

            <hr />
            <button
              onClick={() => {
                setPopup(true);
              }}
            >
              Buy Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TokenSale;
